export const Constants = {
    TRANSPORTATION_TYPE_PRIVATE_CAR: 1,
    TRANSPORTATION_TYPE_COMPANY_CAR: 2,
    TRANSPORTATION_TYPE_PUBLIC_TRANSPORTATION: 3,

    PRIVATE_CAR_AMOUNT_PER_KILOMETER_LIMIT: 20,
    PRIVATE_CAR_AMOUNT_PER_KILOMETER: 0.30,
    PRIVATE_CAR_AMOUNT_PER_KILOMETER_HIGH: 0.38,
    PRIVATE_CAR_FACTOR_PER_PASSENGER: 0.02,

    DAILY_ALLOWANCE_UP_TO_8_HOURS: 0.0,
    DAILY_ALLOWANCE_8_TO_24_HOURS: 14.0,
    DAILY_ALLOWANCE_24_HOURS: 28.0,
};

export const TravelTypes = [
    {value: Constants.TRANSPORTATION_TYPE_COMPANY_CAR, title: 'Firmenwagen, Fahrer'},
    {value: Constants.TRANSPORTATION_TYPE_PUBLIC_TRANSPORTATION, title: 'öffentliches Verkehrsmittel'},
    {value: Constants.TRANSPORTATION_TYPE_PRIVATE_CAR, title: 'privates KfZ, Fahrer'},
];

export const OvernightPaymentTypes = [
    {value: "Firmenkreditkarte", title: "Firmenkreditkarte"},
    {value: "Mastercard MD", title: "Mastercard MD"},
    {value: "Kasse", title: "Kasse"},
    {value: "Auslage", title: "Auslage"},
    {value: "Überweisung", title: "Überweisung"},
    {value: "Paypal", title: "Paypal"},
];

import moment from 'moment';

export class Helpers {
    
    constructor(travel_expense_report) {
        this.travel_expense_report = travel_expense_report;
    }

    transportationTotalCosts() {
        switch (this.travel_expense_report.travel_information.transportation_type) {
            case Constants.TRANSPORTATION_TYPE_PUBLIC_TRANSPORTATION:
                return this.publicTransportationTotalCosts();
            case Constants.TRANSPORTATION_TYPE_PRIVATE_CAR:
                return this.privateCarTotalCosts();
            case Constants.TRANSPORTATION_TYPE_COMPANY_CAR:
                return this.companyCarTotalCosts();
            default:
                return 0.0;
        }
    }

    companyCarTotalCosts() {
        let costs = 0.0;

        this.travel_expense_report.travel_information.company_car.costs.forEach(cost => {
            if (cost.fuel_costs > 0) {
                costs += parseFloat(cost.fuel_costs);
            }
            if (cost.other_costs) {
                costs += parseFloat(cost.other_costs);
            }
        });

        return costs;
    }

    privateCarTotalCosts() {
        let costs = 0.0;

        this.travel_expense_report.travel_information.private_car.costs.forEach(cost => {
            costs += this.privateCarCosts(cost);
        });

        return costs;
    }

    publicTransportationTotalCosts() {
        let costs = 0.0;

        this.travel_expense_report.travel_information.public_transportation.costs.forEach(cost => {
            if (cost.amount > 0) {
                costs += parseFloat(cost.amount);
            }
        });

        return costs;
    }

    overnightStayTotalCosts() {
        let costs = 0.0;

        this.travel_expense_report.travel_information.overnight_stay.costs.forEach(cost => {
            costs += this.overnightStayCosts(cost);
        });

        return costs;
    }

    otherCostsTotal() {
        let costs = 0.0;

        this.travel_expense_report.travel_information.other_cost.costs.forEach(cost => {
            if (cost.amount > 0) {
                costs += parseFloat(cost.amount);
            }
        });

        return costs;
    }

    dailyAllowanceTotalCosts() {
        if (!! this.travel_expense_report.travel_information.daily_allowance) {
            return (this.numberOfDaysWith24Hours() * Constants.DAILY_ALLOWANCE_24_HOURS)
                + (this.numberOfDaysWith8To24Hours() * Constants.DAILY_ALLOWANCE_8_TO_24_HOURS)
                + (this.numberOfDaysWithUpTo8Hours() * Constants.DAILY_ALLOWANCE_UP_TO_8_HOURS)
                + (this.numberOfArrivalAndDepartureDays() * Constants.DAILY_ALLOWANCE_8_TO_24_HOURS)
                + (this.numberOfCrossDays() * Constants.DAILY_ALLOWANCE_8_TO_24_HOURS);
        }

        return 0.0;
    }

    numberOfDaysWith24Hours() {
        let count = 0;

        if(!this.isCrossDay()) {
            this.travel_expense_report.travel_information.period.forEach(day => {
                if (day.entire_day) {
                    count++;
                }
            });
        }

        return count;
    }

    numberOfDaysWith8To24Hours() {
        let count = 0;

        if(!this.isCrossDay()) {
            this.travel_expense_report.travel_information.period.forEach(day => {
                let hours = this.getHoursForDay(day);

                if (!day.entire_day && !this.dayIsArrivalOrDepartureDay(day) && hours >= 8 && hours < 24) {
                    count++;
                }
            });
        }

        return count;
    }

    numberOfDaysWithUpTo8Hours() {
        let count = 0;

        if(!this.isCrossDay()) {
            this.travel_expense_report.travel_information.period.forEach(day => {
                let hours = this.getHoursForDay(day);

                if (!day.entire_day && !this.dayIsArrivalOrDepartureDay(day) && hours < 8) {
                    count++;
                }
            });
        }

        return count;
    }

    numberOfArrivalAndDepartureDays() {
        let count = 0;

        if(!this.isCrossDay()) {
            this.travel_expense_report.travel_information.period.forEach(day => {
                if (!day.entire_day && this.dayIsArrivalOrDepartureDay(day)) {
                    count++;
                }
            });
        }

        return count;
    }

    numberOfCrossDays() {
        let count = 0;

        if ( this.isCrossDay() ) {
            count = 1;
        }

        return count;
    }

    isCrossDay() {
        return (
            this.travelIsTwoDaysLong(this.travel_expense_report.travel_information.period) && 
            this.noOvernightStays(this.travel_expense_report.travel_information.overnight_stay.costs[0])
        );
    }

    dayIsArrivalOrDepartureDay(day) {
        // only one day is no Arrival- or DepartureDay
        if (this.travel_expense_report.travel_information.period.length == 1) return false;

        let days = this.travel_expense_report.travel_information.period.filter(periodDay => {
            return periodDay.date < day.date;
        });

        // is ArrivalDay
        if (days.length === 0) return true;
        
        // is DepartureDay
        if (days.length === (this.travel_expense_report.travel_information.period.length - 1)) return true;
        
        return false;
    }

    travelIsTwoDaysLong(period) {
        return period.length == 2;
    }

    noOvernightStays(cost) {
        return cost.number_of_nights === null;
    }

    getHoursForDay(day) {
        if (day.entire_day) {
            return 24.0;
        }

        return this.diffInHours(day.from, day.to);
    }

    diffInHours(date1, date2) {
        let from = moment(date1, "HH:mm");
        let to = moment(date2 === '00:00' ? '24:00' : date2, "HH:mm");

        return moment.duration(to.diff(from)).asHours();
    }

    calculateMileage(cost) {
        if (cost.mileage_start > 0 && cost.mileage_end > 0) {
            return parseFloat(cost.mileage_end) - parseFloat(cost.mileage_start);
        }

        return 0;
    }

    privateCarCosts(cost) {
        let costs = 0.0;
        let mileage = this.calculateMileage(cost);
        let today = new Date();
        let date = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

        if (this.travel_expense_report.travel_information.period[0].date != 'undefined') {
            date = this.travel_expense_report.travel_information.period[0].date;
        }

        if (mileage > 0) {

            if (date >= "2022-07-01" && mileage > Constants.PRIVATE_CAR_AMOUNT_PER_KILOMETER_LIMIT) {
                costs += (mileage - Constants.PRIVATE_CAR_AMOUNT_PER_KILOMETER_LIMIT) * (Constants.PRIVATE_CAR_AMOUNT_PER_KILOMETER_HIGH + cost.number_of_passengers * Constants.PRIVATE_CAR_FACTOR_PER_PASSENGER); // 30 Cent pro Kilometer
                mileage = Constants.PRIVATE_CAR_AMOUNT_PER_KILOMETER_LIMIT;
            }

            costs += mileage * (Constants.PRIVATE_CAR_AMOUNT_PER_KILOMETER + cost.number_of_passengers * Constants.PRIVATE_CAR_FACTOR_PER_PASSENGER); // 30 Cent pro Kilometer
        }

        return costs;
    }

    overnightStayCosts(cost) {
        let costs = 0.0;

        if (cost.number_of_nights > 0 && cost.amount_per_night > 0) {
            costs += parseFloat(cost.number_of_nights) * parseFloat(cost.amount_per_night);
        }

        return costs;
    }

    totalCosts() {
        return this.transportationTotalCosts()
            + this.overnightStayTotalCosts()
            + this.dailyAllowanceTotalCosts()
            + this.otherCostsTotal();
    }

    formatPrice(price) {
        return parseFloat(price).toFixed(2) + ' €';
    }

    getHoursForDayFormatted(day) {
        if (! day.entire_day && (! day.from || ! day.to)) {
            return '-';
        }

        return this.formatHours(
            this.getHoursForDay(day)
        );
    }

    formatHours(hours) {
        let h = Math.trunc(hours);
        let m = Math.trunc((hours % 1) * 60);

        h = h < 10 ? ("0" + h) : h;
        m = m < 10 ? ("0" + m) : m;

        return `${h}:${m}`;
    }
}
